import { type Clip } from '@air/api/types';

/** Display title for a clip without the file extension. Prefers user-set title over importedName. */
export const getClipDisplayTitle = (
  clip: Pick<Clip, 'title' | 'importedName'> | null | undefined,
  fallbackTitle = '',
): string => {
  return clip?.title || clip?.importedName || fallbackTitle;
};
